import { ComponentColor, ThemeColor } from '@/enums'
import { ShowWhen } from '../../hoc/ShowWhen'
import { Typography } from '../Typography'
import { Container, IconContainer } from './styles'

interface BannerProps {
  title?: string
  text: string
  color: ComponentColor
  icon?: React.ElementType
  iconAlignment?: 'top' | 'center' | 'bottom'
  children?: React.ReactNode
}

export const Banner = ({
  title,
  text,
  color,
  icon: Icon,
  iconAlignment,
  children,
}: BannerProps) =>
  children ? (
    <Container color={color} vertical={Boolean(title)}>
      {children}
    </Container>
  ) : (
    <Container color={color} vertical={Boolean(title)}>
      <IconContainer iconAlignment={iconAlignment}>
        {Icon && <Icon size="menu" />}
      </IconContainer>
      <ShowWhen when={Boolean(title)}>
        <Typography variant="captionB">{title}</Typography>
      </ShowWhen>
      <Typography color={ThemeColor.b50} variant="captionR">
        {text}
      </Typography>
    </Container>
  )
